import { Link as RouterLink } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import { HeroPanel, Section, heroButtonSx } from "../components/ui";
import { tokens } from "../theme";

/** Telehealth landing page. The embedded block is a placeholder for the third-party telehealth integration. */
export default function Telehealth() {
  return (
    <>
      <HeroPanel theme="basalt" eyebrow="Telehealth" title="Care from licensed providers, online."
        subtitle="Start with a short questionnaire. A licensed provider reviews it and tells you whether a program or in-person care fits."
        actions={<>
          <Button size="large" component={RouterLink} to="/get-care" sx={heroButtonSx("basalt")}>Browse care areas</Button>
          <Button size="large" component={RouterLink} to="/how-it-works" sx={heroButtonSx("basalt", "ghost")}>How it works</Button>
        </>}
        minHeight={440} />
      <Section tone="white">
        <Box sx={{ border: `2px dashed ${tokens.line}`, borderRadius: "28px", p: { xs: 3, md: 6 }, textAlign: "center", background: tokens.cream }}>
          <Typography sx={{ fontSize: 12.5, letterSpacing: ".14em", textTransform: "uppercase", color: tokens.muted }}>Third-party integration</Typography>
          <Typography variant="h3" sx={{ fontSize: { xs: 26, md: 34 }, mt: 1.5 }}>Telehealth partner content goes here</Typography>
          <Typography sx={{ mt: 1.5, color: tokens.muted, maxWidth: 560, mx: "auto" }}>
            Placeholder. The embedded visit flow, provider listings or booking widget from VEYSO’s telehealth partner will be added in this block.
            No provider is connected in this preview.
          </Typography>
        </Box>
      </Section>
    </>
  );
}
